"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _Message = require('shared/components/Message');

/* Which side of the clinic/patient line a message's sender is on, for names,
 * avatars and badges. Bubble alignment is "me vs everyone else" and does not
 * use this. An organization API key sends on the clinic's behalf, so it is
 * staff. A SenderType this build doesn't know (a newer backend) is 'unknown':
 * render it neutrally, never as a patient. */


 const getSenderSide = (senderType) => {
  switch (senderType) {
    case _Message.SenderTypes.USER:
    case _Message.SenderTypes.API_KEY:
      return 'staff'
    case _Message.SenderTypes.PATIENT:
      return 'patient'
    default:
      return 'unknown'
  }
}; exports.getSenderSide = getSenderSide

 const isApiKeySender = (senderType) =>
  senderType === _Message.SenderTypes.API_KEY; exports.isApiKeySender = isApiKeySender

/* Shown next to an API key's name in message rows and search results. */
 const API_KEY_SENDER_MARKER = 'API'; exports.API_KEY_SENDER_MARKER = API_KEY_SENDER_MARKER
